import GenericController from './../generic.controller'

export default class Controller extends GenericController {

    constructor(...args) {

        super(...args);

        this.installerMaintenanceAccessTime = '';
        this.timeText = [this.gettext('hour'), this.gettext('an hour'), this.gettext('hours'),
            this.gettext('a minute'), this.gettext('minute'), this.gettext('minutes'),
            this.gettext('month'), this.gettext('a month'), this.gettext('For'),
            this.gettext('a few seconds'), this.gettext('seconds'), this.gettext('a second')];
        this.unlimitedTimeText = this.gettext('unlimited time');
        this.getMaintenanceTime();
    }

    getMaintenanceTime() {
        this._PanelsService.getInstallerMaintenanceAccessTime(this.panelId).then(resp => {
            this._setInstallerAccessTime(resp.data.maintenance_until);
        })
    }

    _setInstallerAccessTime(maintenanceUntil) {
        let now = this.moment(new Date());
        let end = this.moment(this.moment(maintenanceUntil).toDate());
        let duration = this.moment.duration(end.diff(now));
        let daysDiffFromNow = end.diff(now, 'days');

        if (daysDiffFromNow > 30) { // more than a month
            this.installerMaintenanceAccessTime = this.unlimitedTimeText;
        }
        else if (_.isNaN(daysDiffFromNow) || duration <= 0) {
            this.installerMaintenanceAccessTime = null;
        }
        else {
            this.installerMaintenanceAccessTime = this.getTranslatableText(duration.humanize());
        }
    }

    onAccessBlock() {
        this._PanelsService.deleteInstallerMaintenanceAccessTime(this.panelId).then(resp => {
            this._setInstallerAccessTime(resp.data.maintenance_until);
        });
    }

    setInstallerAccessForOneHour() {
        this._PanelsService.setInstallerMaintenanceForONeHourAccessTime(this.panelId).then(resp => {
            this._setInstallerAccessTime(resp.data.maintenance_until);
        });
    }

    setInstallerAccessForEightHours() {
        this._PanelsService.setInstallerMaintenanceForEightHoursAccessTime(this.panelId).then(resp => {
            this._setInstallerAccessTime(resp.data.maintenance_until);
        });
    }
}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/installerAccess.component/controller.js
 **/